import React from 'react';
import { Tooltip } from 'antd';
import { getDefaultStr } from '../../modules/crm/inPatient/service/crmUtils';
import { getDateWithTextMonth } from '../../utils/dateTimeUtils';
import { getTruncatedString } from '../../utils/utility';
import NumberFormatView from '../components/NumberFormatView/NumberFormatView';
import { CRM_INPATIENT_STATUS_COLOUR, getColumnSearchDropdown, IP_DROPDOWN_SEARCH_INPUT_TYPES } from './crmConstants';
import { ReactComponent as Information } from '../../assets/images/svg/i_information.svg';
import CourierStatusTimeLine from '../../modules/crm/inPatient/newAdmission/panels/cards/ClaimDetailHeader/CourierStatusTimeLine';
import CustomFilterDropdownIcon from '../components/filterDropdownComponent/CustomFilterDropdownIcon';
import CustomSort from '../components/customSort/CustomSort';

export const getReimbursementTableMapping = (isNewAdmissionBOH: boolean): any => {
  const inPatientTableMappingColumns = {
    PAYER_NAME: {
      title: (<div className="columnsTitle"><div><Tooltip title="TPA" placement="bottom">Payer</Tooltip>
      </div>
        <span className="sort-icon-container">
          <CustomSort sortKey="payerName" />
        </span>
      </div>),
      customTitle: 'Payer',
      dataIndex: 'payerName',
      key: 'payerName',
      className: 'text-elipsis',
      render: (payerName: any, row: any): any => (
        getTruncatedString(getDefaultStr(payerName, true))
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="payerId" />,
      ...getColumnSearchDropdown({
        filterKey: 'payerId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
        placeholder: 'Search Payer',
        optionPath: '[\'payerList\'][\'reimbursementPayers\']',
      }),
    },
    INSURER_NAME: {
      title: <div className="columnsTitle"><div>Insurer Name</div> <span className="sort-icon-container">
      <CustomSort sortKey="insurerName"/>
    </span></div>,
     customTitle: 'Insurer Name',
      dataIndex: 'insurerName',
      key: 'insurerName',
      className: 'text-elipsis',
      render: (insurerName: any, row: any): any => (
        <Tooltip placement="right" title={row.insurerName}>
          <div className="text-elipsis insurer-name-column">
            {row.insurerName}
          </div>
        </Tooltip>
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="insurerName" />,
      ...getColumnSearchDropdown({
        filterKey: 'insurerName',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
        placeholder: 'Select Insurer Names',
        optionPath: '[\'lookUp\'][\'allInsurers\']',
      }),
    },
    IP_NO: {
      title: 'IP No.',
      dataIndex: 'inPatientNo',
      key: 'inPatientNo',
      render: (inPatientNo: any): any => (
        getDefaultStr(inPatientNo, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="inPatientNo" />,
      ...getColumnSearchDropdown({
        filterKey: 'inPatientNo',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search IP No.',
      }),
    },
    utrNo: {
      title: 'UTR No.',
      dataIndex: 'transactionId',
      key: 'transactionId',
      render: (transactionId: any): any => (
        getDefaultStr(transactionId, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="transactionId" />,
      ...getColumnSearchDropdown({
        filterKey: 'transactionId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search UTR No.',
      }),
    },
    MAID: {
      title: 'Member Id',
      dataIndex: 'memberId',
      key: 'memberId',
      render: (memberId: any): any => (
        getDefaultStr(memberId, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="memberId" />,
      ...getColumnSearchDropdown({
        filterKey: 'memberId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Member Id',
      }),
    },
    policy_number: {
      title: 'Policy Number',
      dataIndex: 'policyNo',
      key: 'policyNo',
      render: (policyNo: any): any => (
        getDefaultStr(policyNo, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="policyNo" />,
      ...getColumnSearchDropdown({
        filterKey: 'policyNo',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Policy Number',
      }),
    },
    CLAIM_NO: {
      title: 'Claim No.',
      dataIndex: 'payerClaimNo',
      key: 'payerClaimNo',
      render: (claimNo: any): any => (
        getDefaultStr(claimNo, true)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="payerClaimNo" />,
      ...getColumnSearchDropdown({
        filterKey: 'payerClaimNo',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Claim No.',
      }),
    },
    MEMBER_NAME: {
      title: (<div className="columnsTitle"><div><Tooltip title="Patient Name" placement="bottom">Patient Name</Tooltip></div>
      <span className="sort-icon-container">
        <CustomSort sortKey="patientName" />
      </span></div>),
      customTitle: 'Patient Name',
      className: 'text-left',
      dataIndex: 'patientName',
      key: 'patientName',
      render: (patientName: any): any => ({
        children: getDefaultStr(patientName, true),
      }
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="patientName" />,
      ...getColumnSearchDropdown({
        filterKey: 'patientName',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search member name',
      }),
    },
    CLAIMED_AMOUNT: {
      title: <div className="columnsTitle text-left"><div>Claimed Amount</div>
      <span className="sort-icon-container">
        <CustomSort sortKey="claimedAmount"/>
        </span></div>,
      customTitle: 'Claimed Amount',
      key: 'claimedAmount',
      dataIndex: 'claimedAmount',
      className: 'column-money text-right',
      render: (amount: any): any => (
        <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="claimedAmount" />,
      ...getColumnSearchDropdown({
        filterKey: 'claimedAmount',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.AMOUNT,
        placeholder: 'Search claimed amount',
      }),
    },
    APPROVED_AMOUNT: {
      title: <div className="columnsTitle text-left"><div>Approved Amount</div>
      <span className="sort-icon-container">
        <CustomSort sortKey="approvedAmount"/>
        </span></div>,
      customTitle: 'Approved Amount',
      key: 'approvedAmount',
      dataIndex: 'approvedAmount',
      className: 'column-money text-right',
      render: (amount: any): any => (
        <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="approvedAmount" />,
      ...getColumnSearchDropdown({
        filterKey: 'approvedAmount',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.AMOUNT,
        placeholder: 'Search approved amount',
      }),
    },
    STATUS: {
      title: <Tooltip title="Claim status" placement="bottom">Status</Tooltip>,
      dataIndex: 'statusName',
      key: 'statusName',
      render: (status: any, data: any): any => {
        let statusClassName = '';

        CRM_INPATIENT_STATUS_COLOUR.map((colorObject: any): any => {
          if (colorObject.StatusId === data?.statusId) {
            statusClassName = colorObject.class;
          }
        });
        return (
          <span className={`fsize_sm bold status-text ${statusClassName}`}>{status && status}</span>
        );
      },
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="statusId" />,
      ...getColumnSearchDropdown({
        filterKey: 'statusId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
        placeholder: 'Select Status',
        optionPath: '[\'lookUp\'][\'payerRIClaimStatuses\']',
      }),
    },
    // LAST_UPDATE: {
    //   title: 'Last Update',
    //   dataIndex: 'lastUpdate',
    //   key: 'lastUpdate',
    //   sorter: true,
    //   sortOrder: false,
    //   render: (date: any): any => (
    //     date && getDateWithTextMonth(date)
    //   ),
    // },
    DOA: {
      title: (<div className="columnsTitle"><div><Tooltip className="force-single-line" title="Date of Admission" placement="bottom">
      DOA <Information className="info-icon" />
    </Tooltip></div><span className="sort-icon-container">
        <CustomSort sortKey="doa" />
      </span></div>),
    customTitle: 'DOA',
      dataIndex: 'doa',
      key: 'doa',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="doa" />,
      ...getColumnSearchDropdown({ filterKey: 'doa', inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE }),
    },
    DOD: {
      title: (<div className="columnsTitle"><div><Tooltip className="force-single-line" title="Date of Discharge" placement="bottom">
        DOD <Information className="info-icon" />
      </Tooltip></div><span className="sort-icon-container">
          <CustomSort sortKey="dod" />
        </span></div>
      ),
      customTitle: 'DOD',
      dataIndex: 'dod',
      key: 'dod',
      render: (date: any): any => (
        date && getDateWithTextMonth(date)
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="dod" />,
      ...getColumnSearchDropdown({ filterKey: 'dod', inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE }),
    },
    COURIER_STATUS: {
      title: 'Courier Status',
      dataIndex: 'courierStatus',
      key: 'courierStatus',
      render: (courierStatus: any, record: any): any => (
        <CourierStatusTimeLine
          courierStatus={courierStatus}
          courierTrackingHistory={record?.courierTrackingHistory}
        />
      ),
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="courierStatus" />,
      ...getColumnSearchDropdown({
        filterKey: 'courierStatus',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search Courier Status',
      }),
    },
  };

  return isNewAdmissionBOH ? {
    CENTER: {
      title: (<div className="columnsTitle"><div>Center</div><span className="sort-icon-container">
      <CustomSort sortKey="dod" />
    </span></div>),
    customTitle: 'Center',
      dataIndex: 'providerName',
      key: 'providerName',
      className: 'text-elipsis',
      render: (providerName: any, row: any): any => (
        getTruncatedString(getDefaultStr(providerName, true))
      ),
      sorter: true,
      sortOrder: false,
      filterIcon: (): any => <CustomFilterDropdownIcon filterKey="providerId" />,
      ...getColumnSearchDropdown({
        filterKey: 'providerId',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
        placeholder: 'Search Center',
        optionPath: '[\'applicationDetail\'][\'_applicationDetail\'][\'groupProviders\']',
        labelKey: 'providerName',
        additionalLabelKey: 'providerRohiniCode',
        additionalLabelKeyDivider: '|',
      }),
    },
    ...inPatientTableMappingColumns,
  } : inPatientTableMappingColumns;
};
